<template>
  <base-widget
    ref="widget"
    expanded
    :initial-tab="0"
    :items="tabs"
    :style="minHeight"
    @tabChanged="$emit('tabChanged', $event)"
  >
    <div class="d-flex align-items-center mb-4 justify-content-between">
      <div>
        <slot name="breadcrumb" />
        <div class="d-flex">
          <div name="title" class="title-client">
            {{ search && search.length ? $t('myclients.searchTitle') : $t('myclients.title') }}
          </div>
          <div
            v-if="!loading"
            class="count-client"
          >
            ({{ count }})
          </div>
        </div>
      </div>
      <div class="d-flex">
        <div @click="trackSearch()">
          <base-search
            v-model="searchTerm"
            icon-position="left"
            class="search-bar"
          />
        </div>
        <base-button
          v-if="hasPermission"
          class="custombutton-clients"
          @click="$emit('addClient')"
        >
          <base-icon
            icon="mplus-client"
          /> {{ $t('myclients.add') }}
        </base-button>
      </div>
    </div>

    <base-list
      :page-size="pageSize"
      :items="items"
      :count="count"
      :loading="loading"
      mode="loadMore"
      show-load-more
      attach-scroll-to-window
      :load-more-bottom-threshold="10"
      @reload="$emit('reload')"
      @load-more="$emit('load-more')"
      @reached-bottom="$emit('load-more')"
    >
      <template slot="loading">
        <base-skeleton
          v-for="n in 4"
          :key="n"
          :opacity="0 + (1 /n)"
        >
          <div class="d-flex align-items-center">
            <div class="skeleton__circle mr-4" />
            <div
              class="skeleton__item mr-5"
              style="max-width: 150px"
            />
            <div
              class="skeleton__item mt-0"
              style="max-width: 100px"
            />
          </div>
        </base-skeleton>
      </template>

      <template v-slot:default="{item}">
        <client-cell
          :item="item"
          @click="cellClicked(item)"
        />
      </template>

      <template
        slot="nodata"
      >
        <client-empty-message v-if="search !== ''" />
        <template v-else>
          <empty :title="$t('myclients.emptyTitle')">
            <a
              v-if="false"
              href="#"
              class="link-orange font-weight-bold"
              @click.prevent="$emit('addClient')"
            >{{ $t("myclients.addAction") }}</a>
            <span v-else class="link-orange font-weight-bold">
              {{ $t("myclients.addAction") }}
            </span> {{ $t('myclients.addActionSuffix') }}
          </empty>
        </template>
      </template>
    </base-list>
  </base-widget>
</template>

<script>
import ClientCell from './ClientsList/myClientCell';
import ClientEmptyMessage from './ClientsList/ClientEmptyMessage';
import minHeightMixin from '../mixins/minheight';

export default {
  name: 'MyClients',
  components: {
    ClientCell,
    ClientEmptyMessage,
  },
  mixins: [minHeightMixin],
  props: {
    pageSize: {
      type: Number,
      default: 10,
    },
    canAddClients: {
      type: Boolean,
      default: true,
    },
    search: {
      type: String,
      default: '',
    },
    count: {
      type: Number,
      default: 0,
    },
    tabs: {
      type: Array,
      // default: () => ['My Clients', 'All Clients', 'Groups'],
      default: () => [
        { text: 'My Clients', disabled: false },
        { text: 'All Clients', disabled: false },
        { text: 'Groups', disabled: false },
      ],
    },
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hasPermission: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchTerm: '',
      searchTimer: null,
    };
  },
  watch: {
    searchTerm(newval) {
      this.cancelSearchTimer();
      if (newval.length) {
        // Cancel previous timer
        this.setSearchTimer(newval);
      } else {
        this.$emit('onSearch', '');
      }
    },
  },
  created() {
    this.hasPermission = this.usePermission('add_client_privilege') || this.useFeature('add_customers');
  },
  methods: {
    setSearchTimer(term) {
      this.searchTimer = window.setTimeout(() => {
        this.$emit('onSearch', term);
      }, 500);
    },
    cancelSearchTimer() {
      if (this.searchTimer !== null) {
        window.clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
    },
    trackSearch() {
      this.$mixpanel.track('search', {
        account_id: this.$store.state.account.user.user.email,
        location: '/clients',
      });
    },
    cellClicked(item) {
      this.$emit('cellClicked', item);
      this.$mixpanel.track('check_client', {
        account_id: this.$store.state.account.user.user.email,
        client: item.email,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.search-bar {
  margin-left: auto;
  min-width: 310px;

  &::v-deep input {
    // min-width: 310px;
    // min-height: 42px;
    font-size: 0.875rem;
  }
}
.client-list {
  &__create-button {
    min-width: 95px;
    margin-left: 1rem;
  }
}
.custombutton-clients{
  font-weight: 500;
  font-size: 14px;
  color: #FFF;
  display: flex;
  padding: 8.5px 10px;
  gap: 8px;
  margin-left: 16px;
  margin-right: unset;
  max-width: 121px;
  max-height: 36px;
  background: #333333;
  border-radius: 5px;
}
::v-deep .base-search {
    margin-right: 0;
    max-width: 320px;
    &__input {
      // font
      font-family: 'SilkaLight' !important;
      // design
      background-color: #FFF;
      border: 1px solid #C6C6C6;
      border-radius: 5px;
      font-family: $font-family-sans-serif-medium;
      max-width: 100%;
    }
  }
::v-deep .base-search__icon--left {
  margin-left: 5px;
}
::v-deep .base-tabs__item{
  margin-left: 4px;
  color: #AAAAAA;
  &.active {
    color: #333333;
  }
}
</style>
